import { render, staticRenderFns } from "./ChatOne.vue?vue&type=template&id=ec27d8e4"
import script from "./ChatOne.vue?vue&type=script&lang=js"
export * from "./ChatOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports